module.exports = __webpack_public_path__ + "static/img/4.48460a10.png";